export enum EDeviceType {
  Desktop = 'desktop',
  Phone = 'phone',
  Tablet = 'tablet',
}
